import populateDays from "../services/dates";

export default function usePopulateDays() {
    return populateDays;
}